import { initPerfume } from 'perfume.js';


declare global {
  interface Window {
    __perfMetrics?: Record<string, any>;
    performanceWorker?: { worker: Worker; setCountry: () => Promise<void>; allowedMetrics: string[] };
  }
}

export const initializePerformanceMetricsTracker = () => {
  initPerfume({
    analyticsTracker: ({ metricName, data }) => {
      if (!window.__perfMetrics) window.__perfMetrics = {};
      if (window.performanceWorker?.allowedMetrics?.includes(metricName)) {
        window.__perfMetrics[metricName] = data;
        window.performanceWorker.worker.postMessage({ type: 'METRIC', metricName, metricData: data, collectedMetrics: window.__perfMetrics, pathname: window.location.pathname });
      }
    },
    maxMeasureTime: 30000,
    resourceTiming: false,
    elementTiming: false,
    reportOptions: {
      lcp: {
        reportAllChanges: true,
      },
      fcp: {
        reportAllChanges: true,
      },
      cls: {
        reportAllChanges: true,
      },
      ttfb: {
        reportAllChanges: true,
      },
      inp: {
        reportAllChanges: true,
      },
    },
  });
};
